import {NgModule} from "@angular/core";
import {NgChartsCommonModule} from "../common/ng-charts-common.module";
import {NgPieChartComponent} from "./pie-chart.component";
import {NgPieLabelComponent} from "./pie-label.component";
import {NgPieSeriesComponent} from "./pie-series.component";
import {NgPieArcComponent} from "./pie-arc.component";

@NgModule({
    imports: [
        NgChartsCommonModule
    ],
    declarations: [
        NgPieChartComponent,
        NgPieLabelComponent,
        NgPieSeriesComponent,
        NgPieArcComponent
    ],
    exports: [
        NgPieChartComponent,
        NgPieLabelComponent,
        NgPieSeriesComponent,
        NgPieArcComponent
    ]
})
export class NgPieChartModule {
}
